import React, { useState } from 'react';
import { MailIcon, LinkedinIcon, MapPinIcon, ArrowDownToLineIcon, CheckCircle2Icon, Loader2Icon, AlertCircleIcon } from 'lucide-react';
import { PROFILE } from '../data/profile';
type Status = 'idle' | 'submitting' | 'success' | 'error';
const INQUIRY_TYPES = ['Independent Board Director seat', 'Audit or Risk Committee mandate', 'Strategic advisory engagement', 'Speaking or panel invitation'];
export function Contact() {
  const [status, setStatus] = useState<Status>('idle');
  const [form, setForm] = useState({
    name: '',
    email: '',
    organization: '',
    message: ''
  });
  const update = (key: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setForm(prev => ({
    ...prev,
    [key]: e.target.value
  }));
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setStatus('error');
      return;
    }
    setStatus('submitting');
    window.setTimeout(() => setStatus('success'), 900);
  };
  return <section aria-labelledby="contact-heading" className="w-full bg-navy-900" data-id="element-42" data-mp="3otmjx61rixxx">
      <div className="mx-auto max-w-content px-6 py-20 sm:py-24 lg:px-8" data-id="element-43" data-mp="3b3svupy30hp9">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-16" data-id="element-44" data-mp="3f4uv36s00tr8">
          <div className="lg:col-span-5" data-id="element-45" data-mp="3f31k5facrndf">
            <h2 id="contact-heading" className="text-[11px] font-semibold uppercase tracking-widest text-gold-400" data-id="element-46" data-mp="314k4m4ulph6l">
              Direct Contact Information
            </h2>
            <p className="mt-6 font-serif text-2xl leading-snug text-white sm:text-3xl" data-id="element-47" data-mp="2s56oitbz1ucw">
              Available for Independent Board Director, Audit Committee, and Strategic
              Advisory roles.
            </p>

            <dl className="mt-10 space-y-7 border-t border-white/10 pt-10" data-id="element-48" data-mp="qdjyatzwm3hh">
              <div className="flex gap-4" data-id="element-49" data-mp="udm0d49jwyxa">
                <MapPinIcon className="mt-0.5 h-5 w-5 flex-none text-gold-500" strokeWidth={1.5} aria-hidden="true" data-id="element-50" data-mp="ucj8ou4emsgb" />
                <div data-id="element-51" data-mp="1yb67nbonc9bm">
                  <dt className="text-[11px] uppercase tracking-widest text-slateink-500" data-id="element-52" data-mp="1yety21ysofm4">
                    Location
                  </dt>
                  <dd className="mt-1.5 text-[15px] text-white" data-id="element-53" data-mp="1pcukjjmzntnx">{PROFILE.location}</dd>
                </div>
              </div>
              <div className="flex gap-4" data-id="element-54" data-mp="2m1aa3fq3m311">
                <MailIcon className="mt-0.5 h-5 w-5 flex-none text-gold-500" strokeWidth={1.5} aria-hidden="true" data-id="element-55" data-mp="2i0qfojwwtdil" />
                <div data-id="element-56" data-mp="28aopnmkzxl11">
                  <dt className="text-[11px] uppercase tracking-widest text-slateink-500" data-id="element-57" data-mp="28b6uv8pmz9l3">
                    Direct Email
                  </dt>
                  <dd className="mt-1.5" data-id="element-58" data-mp="35rdp59mh4b79">
                    <a href={`mailto:${PROFILE.email}`} className="text-[15px] text-white underline decoration-gold-500/50 decoration-1 underline-offset-4 transition-colors hover:text-gold-400" data-id="element-59" data-mp="30zm39ce9itng">
                      {PROFILE.email}
                    </a>
                  </dd>
                </div>
              </div>
              <div className="flex gap-4" data-id="element-60" data-mp="3maa1ht3cxnrh">
                <LinkedinIcon className="mt-0.5 h-5 w-5 flex-none text-gold-500" strokeWidth={1.5} aria-hidden="true" data-id="element-61" data-mp="3mbbei33xokbu" />
                <div data-id="element-62" data-mp="20bbulmdg0j">
                  <dt className="text-[11px] uppercase tracking-widest text-slateink-500" data-id="element-63" data-mp="1h69eh2im3x">
                    LinkedIn
                  </dt>
                  <dd className="mt-1.5" data-id="element-64" data-mp="9sv7prskxvzp">
                    <a href={PROFILE.linkedin} target="_blank" rel="noreferrer noopener" className="text-[15px] text-white underline decoration-gold-500/50 decoration-1 underline-offset-4 transition-colors hover:text-gold-400" data-id="element-65" data-mp="9rjvr4ozdhxi">
                      Connect on LinkedIn
                    </a>
                  </dd>
                </div>
              </div>
            </dl>

            <a href={`mailto:${PROFILE.email}?subject=Board%20Bio%20%2F%20CV%20Request`} className="mt-10 inline-flex items-center gap-2.5 border border-gold-500 px-7 py-3.5 text-[12px] font-semibold uppercase tracking-wider text-gold-400 transition-colors hover:bg-gold-500 hover:text-navy-950" data-id="element-66" data-mp="ewvtxb4ract1">
              <ArrowDownToLineIcon className="h-4 w-4" aria-hidden="true" data-id="element-67" data-mp="3edk96bw55gu8" />
              Request Board Bio / CV
            </a>

            <div className="mt-12 border-t border-white/10 pt-8" data-id="element-68" data-mp="3ncfj9z2b3b2t">
              <h3 className="text-[11px] uppercase tracking-widest text-slateink-500" data-id="element-69" data-mp="3nb4crrhh7p80">
                Inquiries Welcomed
              </h3>
              <ul className="mt-5 space-y-2.5" data-id="element-70" data-mp="12mgmmlqpoofi">
                {INQUIRY_TYPES.map(type => <li key={type} className="flex gap-3 text-sm text-slateink-300" data-id="element-71" data-mp="2kk374236642r">
                    <span className="mt-2 h-1.5 w-1.5 flex-none bg-gold-500" aria-hidden="true" data-id="element-72" data-mp="2km65b9eh73ik" />
                    {type}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-73" data-mp="2gkcahhqyotqb">
            <div className="border border-white/10 bg-navy-800/60 p-8 sm:p-10" data-id="element-74" data-mp="347apeazfntm4">
              {status === 'success' ? <div role="status" className="flex flex-col items-start py-8" data-id="element-75" data-mp="388csj2wh0ptd">
                  <CheckCircle2Icon className="h-9 w-9 text-gold-400" strokeWidth={1.5} aria-hidden="true" data-id="element-76" data-mp="2uiiy85275dc9" />
                  <h3 className="mt-6 font-serif text-2xl text-white" data-id="element-77" data-mp="3n6ycuqhf1tn2">
                    Thank you for reaching out.
                  </h3>
                  <p className="mt-3 max-w-md text-[15px] leading-relaxed text-slateink-300" data-id="element-78" data-mp="3ryy845mjjydb">
                    Your inquiry has been received. Gerry will respond personally within two
                    business days.
                  </p>
                  <button type="button" onClick={() => {
                setForm({
                  name: '',
                  email: '',
                  organization: '',
                  message: ''
                });
                setStatus('idle');
              }} className="mt-8 text-[12px] font-semibold uppercase tracking-wider text-gold-400 underline underline-offset-4" data-id="element-79" data-mp="3rv7hce9isdeo">
                    Send another inquiry
                  </button>
                </div> : <form onSubmit={handleSubmit} noValidate data-id="element-80" data-mp="345vc1phbcphn">
                  <h3 className="font-serif text-xl text-white" data-id="element-81" data-mp="347g8jkn6uii5">Board Inquiry Portal</h3>
                  <p className="mt-2 text-sm text-slateink-300" data-id="element-82" data-mp="2z60mpqd6s7yp">
                    Confidential outreach from boards, nominating committees, and search
                    firms is welcome.
                  </p>

                  <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2" data-id="element-83" data-mp="1ammkz3i9e7s3">
                    <Field id="name" label="Full Name" value={form.name} onChange={update('name')} required data-id="element-84" data-mp="1en6nynpik5m5" />
                    <Field id="email" label="Email" type="email" value={form.email} onChange={update('email')} required data-id="element-85" data-mp="qyx3pq7y7px4" />
                  </div>

                  <div className="mt-6" data-id="element-86" data-mp="10v9ykrf8c9tg">
                    <Field id="organization" label="Organization" value={form.organization} onChange={update('organization')} data-id="element-87" data-mp="15ouwkjgtp3sn" />
                  </div>

                  <div className="mt-6" data-id="element-88" data-mp="32pkgkf04owq6">
                    <label htmlFor="message" className="block text-[11px] font-medium uppercase tracking-widest text-slateink-300" data-id="element-89" data-mp="32qlr8id8fh7d">
                      Nature of Inquiry <span className="text-gold-500" data-id="element-90" data-mp="3brtqb2nkom2i">*</span>
                    </label>
                    <textarea id="message" rows={5} value={form.message} onChange={update('message')} className="mt-3 w-full resize-none border border-white/15 bg-navy-950/60 px-4 py-3 text-[15px] text-white placeholder-slateink-500 transition-colors focus:border-gold-500 focus:outline-none" placeholder="Board seat, audit committee mandate, or advisory engagement…" data-id="element-91" data-mp="36qe4h8dkmbj2" />
                  </div>

                  {status === 'error' ? <p role="alert" className="mt-5 flex items-center gap-2 text-sm text-gold-200" data-id="element-92" data-mp="3bi28v14p9y8">
                      <AlertCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-93" data-mp="rv1z3cfx3hhb" />
                      Please complete your name, email, and inquiry details.
                    </p> : null}

                  <button type="submit" disabled={status === 'submitting'} className="mt-8 inline-flex items-center justify-center gap-2.5 bg-gold-500 px-8 py-4 text-[12px] font-semibold uppercase tracking-wider text-navy-950 transition-colors hover:bg-gold-400 disabled:cursor-not-allowed disabled:opacity-70" data-id="element-94" data-mp="hww1h7158xi9">
                    {status === 'submitting' ? <>
                        <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-95" data-mp="3v9plbp0xwxmq" />
                        Sending
                      </> : 'Submit Inquiry'}
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}
type FieldProps = {
  id: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  required?: boolean;
};
function Field({
  id,
  label,
  value,
  onChange,
  type = 'text',
  required
}: FieldProps) {
  return <div data-id="element-96" data-mp="5aoiia49uwea">
      <label htmlFor={id} className="block text-[11px] font-medium uppercase tracking-widest text-slateink-300" data-id="element-97" data-mp="5awwy6g1m9rl">
        {label}
        {required ? <span className="text-gold-500" data-id="element-98" data-mp="3so8vl4sjr074"> *</span> : null}
      </label>
      <input id={id} type={type} value={value} onChange={onChange} className="mt-3 w-full border border-white/15 bg-navy-950/60 px-4 py-3 text-[15px] text-white placeholder-slateink-500 transition-colors focus:border-gold-500 focus:outline-none" data-id="element-99" data-mp="3so0knifzi4yk" />
    </div>;
}